function initFilteredListings() {

	var $grid = $('.listing-grid').imagesLoaded(function () {
		// init Isotope after all images have loaded
		$grid.isotope({
			itemSelector: '.listing-grid-item', // use a separate class for itemSelector, other than .col-
			percentPosition: true,
			animationEngine: 'best-available',
			transitionDuration: 0,
			transformsEnabled: false,
			masonry: {
				columnWidth: '.listing-grid-item'
			}
		});
	});

	$grid.on('layoutComplete', function (event, filteredItems) {
		setTimeout(function () {
			matchHeightReset();
		}, 501);
	});

	// Filtres multiples
	// store filter for each group
	var filters = [];

	// change is-checked class on buttons
	$('.filter-group .filter').on('click', function (event) {
		$('.sidebar__toggle').removeClass('open');
		$('.sidebar').removeClass('open');
		var $target = $(event.currentTarget);
		$target.toggleClass('is-checked');
		var isChecked = $target.hasClass('is-checked');
		var filter    = $target.attr('data-filter');

		$('.listing-grid-item').addClass('on--move');

		currentCat = $(this).closest('.filter-group').data('filter-group');
		reset      = $(this).closest('.sidebar__drawer').find('.filter').not(this);
		reset.each(function () {
			removeFilter( $(this).attr('data-filter') );
			$(this).removeClass('is-checked');

			if ($(this).hasClass('filter--reset') && $(this).closest('.filter-group').data('filter-group') !== currentCat) {
				$(this).addClass('is-checked');
			}
		});

		if (isChecked) {
			addFilter( filter );
		} else {
			removeFilter( filter );
		}

		// filter isotope
		// group filters together, inclusive
		$grid.isotope({filter: filters.join('')});
		$grid.on('arrangeComplete', function (event, filteredItems) {
			$('.listing-grid-item:visible .activity-cat__count').each(function (index) {
				$(this).find('.current-inner').html(index + 1);
				$(this).find('.total').html(filteredItems.length);
				$('.listing-grid-item').removeClass('on--move');
			});

			matchHeightReset();
		});

		if (!$grid.data('isotope').filteredItems.length) {
			$('.listing-empty').fadeIn('slow');
		} else {
			$('.listing-empty').fadeOut('fast');
		}
	});

	$('.filter-group--no-isotope .filter').on('click', function () {
		var $this          = $(this);
		var $currentFilter = $(this).data('filter');

		$('.filter').removeClass('is-checked');
		$this.addClass('is-checked');
		$('.sidebar__toggle').removeClass('open');
		$('.sidebar').removeClass('open');

		if ($currentFilter == "all") {

			console.log("all");

			$('.listing-grid-item').removeClass('hidden');

			setTimeout(function () {
				$('.listing-grid-item').removeClass('item-hide');
			}, 350);

		} else {

			console.log($currentFilter);

			$('.listing-grid-item').addClass('item-hide');


			setTimeout(function () {
				$('.listing-grid-item').addClass('hidden');

				$('.listing-grid-item').each(function () {
					var $this = $(this);
					if ($this.hasClass($currentFilter)) {
						$this.removeClass('hidden');

						setTimeout(function () {
							$this.removeClass('item-hide');
						}, 300);
					}
				});

			}, 300);
		}

		setTimeout(function () {
			matchHeightReset();
		}, 300);
	});

	//Filtre Unique
	var filters1 = {};

	$('.filter1').on('click', function () {
		var $this = $(this);
		$('.filter1').removeClass('is-checked');
		$this.addClass('is-checked');
		$('.sidebar__toggle').removeClass('open');
		$('.sidebar').removeClass('open');
		// get group key
		var $buttonGroup1      = $this.parents('.filter1-group');
		var filterGroup1       = $buttonGroup1.attr('data-filter-group');
		// set filter for group
		filters1[filterGroup1] = $this.attr('data-filter');
		// combine filters
		var filterValue1       = concatValues(filters1);
		$grid.isotope({filter: filterValue1});

		if (!$grid.data('isotope').filteredItems.length) {
			$('.listing-empty').fadeIn('slow');
		} else {
			$('.listing-empty').fadeOut('fast');
		}
	});


	var $gridFaq = $('.listing-faq').imagesLoaded(function () {
		$gridFaq.isotope({
			itemSelector: '.listing-faq-item', // use a separate class for itemSelector, other than .col-
			percentPosition: true,
			masonry: {
				columnWidth: '.listing-faq-item'
			}
		});
	});

	//Filtre Unique
	var filtersFaq = {};

	$('.faqs__filter .filter').on('click', function () {
		var $this = $(this);
		$('.faq').removeClass('show');
		$('.faqs__filter .filter').removeClass('is-checked');
		$this.addClass('is-checked');
		// get group key
		var $buttonGroupFaq        = $('.faqs__filter');
		var filterGroupFaq         = $buttonGroupFaq.attr('data-filter-group');
		// set filter for group
		filtersFaq[filterGroupFaq] = $this.attr('data-filter');
		// combine filters
		var filterValueFaq         = concatValues(filtersFaq);
		$gridFaq.isotope({filter: filterValueFaq});
	});

	$('.faq__question').on('click', function () {
		$(this).closest('.faq').toggleClass('show');
		$gridFaq.isotope('layout');
	});


	// flatten object by concatting values
	function concatValues(obj) {
		var value = '';
		for (var prop in obj) {
			value += obj[prop];
		}
		return value;
	}

	function addFilter(filter) {
		if (filters.indexOf(filter) == -1) {
			filters.push(filter);
		}
	}

	function removeFilter(filter) {
		var index = filters.indexOf(filter);
		if (index != -1) {
			filters.splice(index, 1);
		}
	}
}

